import {useLocation, useNavigate} from "react-router-dom";
import {AppContext} from "../../lib/AppContext";
import {createRef, useContext, useEffect, useMemo, useState} from "react";
import {Card, CardContent} from "@mui/material";
import Meta from "../common/Meta";
import moment from "moment";
import ContextSearchNavbar from "../navbars/ContextSearchNavbar";
import DashboardLayout from "../LayoutContainers/DashboardLayout";
import MDBox from "../../components/MDBox";
import Footer from "../Footer";
import {getCookie, setCookie} from "../common/appCookie";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import Grid from "@mui/material/Grid";
import MDTypography from "../../components/MDTypography";
import {formatCurrency} from "../common/Utils";
import {CONSTANTS} from "../common/constants";
import {getMemberMonthlyBilling} from "../common/api/ReportApi";

export default function MemberBillingCalendar(props) {
  const location = useLocation();

  const navigate = useNavigate();

  const [specialEvents, setSpecialEvents] = useState(props?.specialEvents);

  useEffect(() => {
    setSpecialEvents(props?.specialEvents);
  }, [props?.specialEvents]);

  const calendarRef = createRef();

  const [context, setContext] = useContext(AppContext);
  const [initialLoad, setInitialLoad] = useState(true);
  const [calendarView, setCalendarView] = useState(getCookie('calendarView') || false);

  const toggleMonthView = () => {
    setCookie('calendarView', !calendarView, 1);
    setCalendarView(!calendarView);
  }

  const addInventoryEventFn = (eventDate) => {
    let formattedDate = '';
    if (eventDate) {
      formattedDate = '?initDate=' + moment(eventDate || new Date()).format('YYYY-MM-DD HH:mm Z');
    }
    navigate('/sales/create/' + (specialEvents ? 'party' : 'event') + formattedDate);
  }

  const [eventsFiltered, setEventsFiltered] = useState([]);


  const [inventoryRender, setInventoryRender] = useState(1);
  const [events, setEvents] = useState([]);
  const [eventsLoading, setEventsLoading] = useState(true);
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    setEventsFiltered(events);
  }, [events])

  const dateClick = function (info) {
    return;
    let calendarApi = calendarRef.current.getApi();

    // Change the view to 'timeGridDay' and navigate to the clicked date
    calendarApi.changeView('timeGridDay', info.date);

  }

  const eventClick = function (info) {
    navigate(`/client/${info.event?.extendedProps?.guid}`);
  }

  function renderEventContent(eventInfo) {
    let bgColor = 'inherit';
    let fontColor = 'inherit';
    if (eventInfo?.event?.extendedProps?.history) {
      bgColor = '#ccc'
    }
    if (eventInfo?.event?.extendedProps?.eventType?.fontColor) {
      fontColor = eventInfo?.event?.extendedProps?.eventType?.fontColor
    }
    return (
      <Card
        style={{
          backgroundColor: bgColor,
          padding: 0
        }}
        className={"w-100"}>
        <CardContent style={{
          margin:0,
          padding:'4px 8px'
        }}>
          <MDTypography variant="p" style={{
            color: fontColor
          }} fontWeight="bold">
            {eventInfo.event?.title}
          </MDTypography>
          <br/>
          <MDTypography variant="p" style={{
            color: fontColor
          }} fontWeight="regular">
            {eventInfo.event?.extendedProps?.accountPrice}
            <br/>
            <span style={{
              fontSize: '10px !important'
            }}>{eventInfo.event?.extendedProps?.displayTime}</span>
          </MDTypography>
        </CardContent>
      </Card>
    )
  }

  const getInventoryEventsFn = async (req, client) => {
    setEventsLoading(true);
    let result = await getMemberMonthlyBilling(req, inventoryRender);
    let _events = [];

    for (let i = 0; i < result?.items?.reportItems?.length; i++) {
      let event = result.items.reportItems[i];
      let _e = {
        guid: event.member.guid,
        title: event.member.firstName + ' ' + event.member.lastName,
        start: event.nextBillingDate,
        end: event.nextBillingDate,
        history: event?.history,
        displayTime: event.accountType.name,
        accountPrice: formatCurrency(event.accountPrice)
      }
      _events.push(_e);
    }
    setEvents(_events);
    setEventsLoading(false);
    setInventoryRender(result?.render);
    setLoading(false);
  }


  const handleDatesSet = (info) => {
    let startDate = new Date(info.start);
    startDate.setHours(0, 0, 0, 0);
    let endDate = new Date(info.end);

    let req = {
      start: startDate,
      end: endDate,
      specialEvents: specialEvents
    }
    getInventoryEventsFn(req, null);
  }

  return (

    <DashboardLayout>
      <Meta pageTitle={'Member Billing Calendar'}/>
      <ContextSearchNavbar title={'Member Billing Calendar'}/>
      <MDBox py={3}>
        <MDBox mb={3}>
          <Card>
            <CardContent>

              <MDBox mb={3}>
                <Grid container>
                  <Grid item xs={12} xl={12}>
                    {useMemo(
                      () => (<FullCalendar
                        ref={calendarRef}
                        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                        initialView='dayGridMonth'
                        weekends={true}
                        height={'auto'}
                        contentHeight={'auto'}
                        eventContent={renderEventContent}
                        datesSet={handleDatesSet}
                        events={eventsFiltered}
                        headerToolbar={CONSTANTS.CALENDAR_TOOLBAR}
                        dateClick={dateClick}
                        eventClick={eventClick}
                      />), [eventsFiltered]
                    )}
                  </Grid>
                </Grid>
              </MDBox>

            </CardContent>
          </Card>
        </MDBox>
      </MDBox>

      <Footer mt={5}/>

    </DashboardLayout>
  );
}